import type {
    DirectionType
} from "../../types/locale";

export type LanguageDirectionConstantType = {
    lang: string;
};

export type LangDirectionConflictConstantType = {
    direction: DirectionType;
    lang?: string;
};

const RTL_SCRIPTS: Array<string> = [
    "Arab",
    "Syrc",
    "Samr",
    "Mand",
    "Thaa",
    "Mend",
    "Nkoo",
    "Adlm",
    "Rohg",
    "Hebr"
];

const RTL_LANGUAGES: Array<string> = [
    "ckb",
    "arc",
    "bcc",
    "bqi",
    "far",
    "glk",
    "khw",
    "mzn",
    "nqo",
    "pnb",
    "ae",
    "ar",
    "dv",
    "fa",
    "he",
    "iw",
    "ks",
    "ku",
    "ps",
    "sd",
    "ug",
    "ur",
    "yi"
];

export const getLanguageDirection = ({
    lang
}: LanguageDirectionConstantType): DirectionType => {
    try {
        const script = new Intl.Locale(lang).maximize().script;

        return script && RTL_SCRIPTS.includes(script) ? "rtl" : "ltr";
    } catch {
        return RTL_LANGUAGES.includes(lang.split("-")[0]?.toLowerCase() ?? "") ? "rtl" : "ltr";
    }
};

export const isLangDirectionConflict = ({
    direction,
    lang
}: LangDirectionConflictConstantType): boolean => {
    if(!lang) {
        return false;
    }

    return getLanguageDirection({
        lang
    }) !== direction;
};
